export const Payments_Route = "payments";
export const Invoices_Route = "invoices";
export const ProformaInvoices_Route = "proforma-invoices";
export const Requirements_Route = "requirements";

// Contracts
export const Contracts_Route = "contracts";
export const Contracts_Invoice_Simulation_Route = "invoice-simulation";
export const Contracts_Invoice_Simulation_Detail_Route = "invoice-simulation/detail";